import axios from 'axios'
import { get } from 'lodash'

const apiMiddleware = store => next => action => {
    if (action.type !== 'ADMIN_API_CALL' && action.type !== 'API_CALL') {
        return next(action)
    }

    const { method, path, data } = action
    const token = store.getState().auth.token
    const admin = action.type === 'ADMIN_API_CALL'
    const apiRoot = admin ? '/api/admin' : '/api'

    if (!data) {
        return axios[method](`${apiRoot}/${path}`, {
            headers: {
                Authorization: admin ? token : ''
            }
        })
            .then(res => {
                if (res.data.success) {
                    return res.data
                }
                else throw new Error('Odottamaton virhe')
            })
            .catch(err => {
                // Get the response error
                var errObj = get(err, 'response.data.error')

                if (!errObj) {
                    errObj = new Error('Yhteysongelma')
                }

                if (!errObj.message) {
                    errObj.message = 'Odottamaton virhe'
                }

                // Log out if unauthorized
                if (errObj.status === 401) {
                    store.dispatch({ type: 'LOGOUT' })
                }

                throw new Error(errObj.message)
            })

    }

    return axios[method](`${apiRoot}/${path}`, data, {
        headers: {
            Authorization: admin ? token : ''
        }
    })
        .then(res => {
            if (res.data.success) {
                return res.data
            }
            else throw new Error('Odottamaton virhe')
        })
        .catch(err => {
            var errObj = get(err, 'response.data.error')

            if (!errObj) {
                errObj = new Error('Yhteysongelma')
            }

            if (!errObj.message) {
                errObj.message = 'Odottamaton virhe'
            }

            if (errObj.status === 401 && path !== 'login') {
                store.dispatch({ type: 'LOGOUT' })
            }

            throw new Error(errObj.message)
        })

}

export default apiMiddleware



// WEBPACK FOOTER //
// ./src/redux-middleware/apiMiddleware.js